import { e as c } from "./index15.js";
import { b as u, g as f } from "./utils.js";
function p(n) {
  const e = (Array.isArray(n) ? n : [n]).map(
    (r) => new URL(r)
  );
  return e.length === 0 ? () => 0 : function(t, o) {
    const i = e.findIndex(
      (a) => m(new URL(t.url), a)
    ), s = e.findIndex(
      (a) => m(new URL(o.url), a)
    );
    return i === s ? 0 : i !== -1 && (s === -1 || i < s) ? -1 : s !== -1 && (i === -1 || s < i) ? 1 : 0;
  };
}
function m(n, e) {
  return n.hostname === e.hostname && n.pathname.startsWith(e.pathname);
}
function w(n, { tck: e } = {}) {
  return n.map((r) => {
    const t = {
      href: e ? u(r.url, { tck: e }) : r.url,
      children: r.title
    }, { sourceType: o } = r.metadata ?? {};
    return o && c(o) ? {
      ...t,
      variant: o
    } : t;
  });
}
function l(n, e = {}) {
  return n.references && n.references.length > 0 ? w(n.references, { tck: e.tck }) : void 0;
}
function R() {
  const n = f();
  if (!n)
    return () => 0;
  const r = [
    new URL("https://mongodb.com/docs"),
    new URL("https://www.mongodb.com/docs"),
    new URL("https://mongodb.com/developer"),
    new URL("https://www.mongodb.com/developer"),
    new URL("https://learn.mongodb.com"),
    new URL("https://mongodb.com"),
    new URL("https://www.mongodb.com")
  ].filter(
    (t) => m(n, t)
  );
  return p(r);
}
export {
  w as f,
  l as g,
  R as m
};
